<div class="page-container">
  <!-- Opened from My Events: one event's tickets, with what is on their wallets. -->
  <div *ngIf="eventUid; else allTicketsHeader" class="page-header">
    <a class="back-link" routerLink="/my-events">
      <i nz-icon nzType="arrow-left" aria-hidden="true"></i> My Events
    </a>
    <h1>{{ viewedEvent?.name || 'Event tickets' }}</h1>
    <p>Your tickets for this event</p>

    <div *ngIf="viewedEventWalletTotals.length" class="event-wallet-summary">
      <i nz-icon nzType="wallet" aria-hidden="true"></i>
      <span class="event-wallet-label">On your wallets for this event</span>
      <span class="event-wallet-total" *ngFor="let total of viewedEventWalletTotals">
        {{ total.balance }} {{ total.currencyCode }}
      </span>
    </div>
  </div>

  <ng-template #allTicketsHeader>
    <div class="page-header">
      <h1>My Tickets</h1>
      <p>Your active and past event tickets</p>
    </div>
  </ng-template>

  <nz-spin [nzSpinning]="loading">
    <div *ngIf="visibleTickets.length > 0; else noTickets" class="tickets-grid">
      <div *ngFor="let ticket of visibleTickets" class="ticket-card">
        <div class="ticket-header">
          <div class="ticket-number">#{{ ticket.ticketNumber }}</div>
          <span class="ticket-status" [ngClass]="'status-' + (ticket.ticketStatus || 'unknown')?.toLowerCase()">
            {{ ticket.ticketStatus }}
          </span>
        </div>

        <!-- Tap anywhere on the body for the full ticket. The footer controls stop propagation so
             they keep doing their own thing. -->
        <div
          class="ticket-body is-clickable"
          role="button"
          tabindex="0"
          [attr.aria-label]="'View details for ticket ' + ticket.ticketNumber"
          (click)="openTicketDetail(ticket)"
          (keydown.enter)="openTicketDetail(ticket)"
          (keydown.space)="openTicketDetail(ticket)"
        >
          <h3 class="ticket-event-name">{{ ticket.event?.name }}</h3>
          <div class="ticket-details">
            <div class="ticket-detail">
              <i nz-icon nzType="calendar" aria-hidden="true" class="detail-icon"></i>
              <span>{{ ticket.event?.date | date:'mediumDate' }}</span>
            </div>
            <div class="ticket-detail">
              <i nz-icon nzType="environment" aria-hidden="true" class="detail-icon"></i>
              <span>{{ ticket.event?.location?.description || 'Online' }}</span>
            </div>
            <div class="ticket-detail">
              <i nz-icon nzType="tag" aria-hidden="true" class="detail-icon"></i>
              <span>{{ ticket.ticketType?.name }}</span>
            </div>
            <!--
              GAP-1: a customer could fund a wallet and then never see what was on it. It sits with
              the other ticket facts rather than in the action row — it is information, not an
              action, and four controls plus a balance pill overflowed the 317px footer badly enough
              that overflow:hidden clipped the Top Up label and pushed the Order link out of the card.
            -->
            <div
              *ngIf="ticket.event?.walletsEnabled && walletBalanceFor(ticket.uid).length"
              class="ticket-detail wallet-balance"
            >
              <i nz-icon nzType="wallet" aria-hidden="true" class="detail-icon"></i>
              <span>
                <span
                  *ngFor="let leg of walletBalanceFor(ticket.uid)"
                  class="wallet-balance-leg"
                >
                  {{ leg.balance }} {{ leg.currencyCode }}
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="ticket-footer" (click)="$event.stopPropagation()">
          <div class="ticket-actions">
            <!-- <a
              nz-button
              nzType="primary"
              nzSize="small"
              [href]="getTicketDownloadUrl(ticket.uid)"
              target="_blank"
              rel="noopener"
              aria-label="View ticket {{ ticket.ticketNumber }}"
            >
              <i nz-icon nzType="eye" aria-hidden="true"></i> View
            </a> -->
            <button
              nz-button
              nzType="default"
              nzSize="small"
              (click)="openShareModal(ticket.uid); $event.stopPropagation()"
              aria-label="Share ticket {{ ticket.ticketNumber }}"
            >
              <i nz-icon nzType="share-alt" aria-hidden="true"></i> Share
            </button>
            <a
              nz-button
              nzType="default"
              nzSize="small"
              [href]="getTicketDownloadUrl(ticket.uid)"
              download
              aria-label="Download ticket {{ ticket.ticketNumber }}"
            >
              <i nz-icon nzType="download" aria-hidden="true"></i> Download
            </a>
            <!--
              Only events running ticket wallets can be topped up. This link used to render on
              every ticket, so customers on a non-wallet event followed it to a guaranteed failure
              (QA finding BUG-14). Passing the uid as well as the number lets the server resolve
              the exact ticket rather than guess between tickets sharing that number (BUG-9).
            -->
            <a
              *ngIf="ticket.event?.walletsEnabled && hasWallet(ticket.uid)"
              nz-button
              nzType="default"
              nzSize="small"
              [routerLink]="['/wallet-top-up']"
              [queryParams]="{
                ticketUid: ticket.uid,
                ticketNumber: ticket.ticketNumber
              }"
              aria-label="Top up wallet for ticket {{ ticket.ticketNumber }}"
            >
              <i nz-icon nzType="wallet" aria-hidden="true"></i> Top Up Wallet
            </a>
          </div>
          <a class="order-link" [routerLink]="['/orders', ticket.orderNumber]">
            Order <i nz-icon nzType="right" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>

    <ng-template #noTickets>
      <div class="empty-state">
        <div class="empty-icon">
          <i nz-icon nzType="inbox" aria-hidden="true"></i>
        </div>
        <h3 class="empty-title">No Tickets Yet</h3>
        <p class="empty-desc">Purchase tickets to events and they will appear here.</p>
        <a nz-button nzType="primary" routerLink="/events">
          Browse Events
        </a>
      </div>
    </ng-template>
  </nz-spin>
</div>
